"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
require("./subscribeModal.scss");
const subscription_1 = require("../../../../utils/subscription");
const react_redux_1 = require("react-redux");
const date_fns_1 = require("date-fns");
const SubscribeModal = (props) => {
    const { title, open = false, cancelable, handleClick, trial = false, subscriptionData, subscription: { quantity, upcomingCharge, trialDays } } = props;
    const submitLocal = () => {
        cancelable();
    };
    const subscribed = subscription_1.isSubscribed(subscriptionData);
    const renewalDate = trial ? date_fns_1.format(date_fns_1.addDays(new Date(), trialDays), "MM/dd/yyyy") :
        subscription_1.renewDate(subscriptionData);
    const description = react_1.default.createElement(react_1.default.Fragment, null,
        (!subscribed && renewalDate && !trial) ? 'Your current subscription is still active.' : '',
        trial ? 'Your free trial is active.' : '',
        "You will be charged ",
        react_1.default.createElement("span", null,
            "$",
            upcomingCharge,
            " "),
        "for ",
        react_1.default.createElement("span", null, quantity),
        " user(s)",
        renewalDate ? react_1.default.createElement(react_1.default.Fragment, null,
            " on ",
            react_1.default.createElement("span", null, renewalDate)) : '',
        ".");
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(core_1.Dialog, { open: open, onClose: () => { submitLocal(); }, fullWidth: true, maxWidth: 'sm', className: 'successfully-subscribe' },
            react_1.default.createElement(core_1.IconButton, { "aria-label": "close", className: 'close-btn', onClick: () => { submitLocal(); } },
                react_1.default.createElement(Close_1.default, { className: 'modal-close-icon' })),
            react_1.default.createElement("div", { className: 'checked-icon-subscribe' }),
            react_1.default.createElement("div", { className: "modal-container text-left" },
                title && react_1.default.createElement("h4", { className: "modal-title" }, title),
                react_1.default.createElement("p", { className: "c-m-description" }, description),
                react_1.default.createElement("div", { className: "action-group" },
                    react_1.default.createElement("button", { onClick: () => {
                            handleClick(trial);
                        }, className: 'v1-btn btn-primary-center' }, "Subscribe"))))));
};
const mapStateToProps = (state) => {
    const { subscription } = state;
    return {
        subscription
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(SubscribeModal);
